import { render, staticRenderFns } from "./WholeSearchBar.vue?vue&type=template&id=1fc84de3&scoped=true"
import script from "./WholeSearchBar.vue?vue&type=script&lang=ts"
export * from "./WholeSearchBar.vue?vue&type=script&lang=ts"
import style0 from "./WholeSearchBar.vue?vue&type=style&index=0&id=1fc84de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc84de3",
  null
  
)

export default component.exports